export const PRIVILEGED_ROLES = ["admin", "CS", "sales", "field_manager"];